module.exports = __webpack_public_path__ + "media/signup-react/complete-profile-709b03cf.png";